import React from "react";
import "../Styles/Blog.css";
import CatCow from "../assets/catcow.jpeg";
import PelvicTilt from "../assets/pelvic.jpeg";
import WallSit from "../assets/wallsit.jpeg";
import Shoulder from "../assets/shoulder.jpeg";
import BridgePose from "../assets/bridge.jpeg";

const Blog = () => {
  return (
    <div className="blog-container">
      <h1 className="title">Back Pain Relief & Posture Tips for Women</h1>
      <h3 className="title">Physiotherapy Exercises by Dr. Nivedita Pashte</h3>
      <p className="desc">
        Learn simple physiotherapy exercises and posture correction tips by Dr.
        Nivedita Pashte to reduce back pain, improve pelvic health, and boost
        women’s overall fitness.
      </p>

      <h1 className="title">Back Pain and Posture: Simple Physiotherapy Tips for Women</h1>
      <p className="desc">
        In today’s fast-paced lifestyle, back pain, poor posture, and knee pain
        have become common challenges for women of all age groups—whether you’re
        a working professional, a new mother, or a student. To address these
        issues, physiotherapist Dr. Nivedita Pashte shares highly practical tips
        in her insightful session:
        <a
          href="https://www.youtube.com/embed/S4xT0loGeec"
          target="_blank"
          rel="noopener noreferrer"
          className="video-link"
        >
          {" "}
          पाठीच्या वेदना, पोश्चर आणि फिटनेस — महिलांसाठी खास उपाय!
        </a>
        . This blog will highlight the most important takeaways from the video,
        explain simple exercises step by step, and provide additional resources
        to help you achieve better posture, reduce pain, and improve your
        overall health.
      </p>

      <h2 className="title">Why Women Need Special Focus on Posture & Fitness</h2>
      <ul>
        <li className="desc">Reducing back pain through posture correction</li>
        <li className="desc">Strengthening the pelvic floor muscles</li>
        <li className="desc">Relieving knee pain and stiffness</li>
        <li className="desc">Supporting hormonal and weight-related changes</li>
      </ul>
 <p className="video-bottom">
        For the full session with demonstrations, you can watch the video{" "}
        
        <a
          href="https://www.youtube.com/embed/S4xT0loGeec"
          target="_blank"
          rel="noopener noreferrer"
                    className="video-link"
        >
          
          here
        </a>
        .
      </p>
      <h2 className="title">5 Important Exercises from Dr. Pashte’s Session</h2>

      {/* Exercises */}
      <div className="exercise">
        <div className="exercise-text">
          <h4 className="title">1. Cat-Cow Stretch (For Spinal Flexibility)</h4>
      <p className="desc">
            Begin on all fours, inhale arch your back (cow), exhale round your
            spine (cat).
          </p>
          <strong>
            Cat-Cow stretch for back pain relief and posture improvement
          </strong>
        </div>
        <img src={CatCow} alt="Cat Cow" />
      </div>

      <div className="exercise">
        <div className="exercise-text">
          <h4 className="title">2. Pelvic Tilt Exercise (For Core & Pelvic Floor Strength)</h4>
                <p className="desc">
Lie on back, bend knees, tighten core, flatten lower back.</p>
          <strong>
            Pelvic tilt exercise for pelvic floor and lower back strength
          </strong>
        </div>
        <img src={PelvicTilt} alt="Pelvic Tilt" />
      </div>

      <div className="exercise">
        <div className="exercise-text">
          <h4 className="title">3. Wall Sit (For Knee & Lower Body Strength)</h4>
                <p className="desc">
Slide down wall until knees are 90°, hold for 20–30s.</p>
          <strong>Wall sit exercise for knee strength and posture support</strong>
        </div>
        <img src={WallSit} alt="Wall Sit" />
      </div>

      <div className="exercise">
        <div className="exercise-text">
          <h4 className="title">4. Shoulder Blade Squeeze (For Posture Correction)</h4>
                <p className="desc">
Squeeze shoulder blades together for 5s, repeat 10 times.</p>
          <strong>Shoulder blade squeeze for posture correction</strong>
        </div>
        <img src={Shoulder} alt="Shoulder blade" />
      </div>

      <div className="exercise">
        <div className="exercise-text">
          <h4 className="title">5. Bridge Pose (For Lower Back & Core Strength)</h4>
                <p className="desc">
Lift hips upward, hold 5–10s, slowly lower.</p>
          <strong>
            Bridge pose exercise for lower back strength and flexibility
          </strong>
        </div>
        <img src={BridgePose} alt="Bridge Pose" />
      </div>

      <h2 className="title">Holistic Tips Beyond Exercises</h2>
      <ul>
        <li className="desc">Balanced diet with anti-inflammatory foods</li>
        <li className="desc">Stress management with relaxation techniques</li>
        <li className="desc">Staying active with walking, yoga, or light training</li>
      </ul>

      <h2 className="title">Final Thoughts</h2>
            <p className="desc">
        Back pain and posture issues should not be ignored. Start with 10
        minutes daily, and you’ll see a remarkable difference in posture and
        energy levels.
      </p>
      <div style={{paddingLeft:"40px"}}>
            <p className="video-bottom">
        If you want to watch all demonstrations directly, check out the full
        video:{" "}
        <a
          href="https://www.youtube.com/embed/S4xT0loGeec"
          target="_blank"
          rel="noopener noreferrer"
                    className="video-link"

        >
          पाठीच्या वेदना, पोश्चर आणि फिटनेस — महिलांसाठी खास उपाय!
        </a>
      </p>
      <p className="video-tip">
        👉 Start today with just 10 minutes daily, and you’ll see a remarkable
        difference in your posture and energy levels.
      </p></div>
    </div>
  );
};

export default Blog;
